<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="规范名称：" prop="standardName">
              <el-input  maxlength="100" v-model="ruleForm.standardName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="编号：" prop="standardCode">
              <el-input maxlength="100"  v-model="ruleForm.standardCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtny" @click="submit">确定</el-button>
        <el-button v-waves class="mybtny" @click="resetForm">重置</el-button>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        standardName: '',
        standardCode: '',
      },
      rules: {
        standardName: [
          { required: true, message: '请输入规范名称', trigger: 'blur' }
        ],
        standardCode: [
          { required: true, message: '请输入规范编号', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.ruleForm, true);
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    handleChange(file, fileList) {
      this.files = fileList.slice(-1);
    },
  },
}
</script>

<style lang='less' scoped>
.addModel {
  .addfrom {
    margin: 0 30px;
    .topcontent {
      margin-bottom: 20px;
      .el-row {
        margin-bottom: 0;
        height: 40;
      }
      p {
        padding: 0 10px;
      }
    }
    .el-row {
      margin-bottom: 22px;
      &:last-child {
        // margin-bottom: 0;
      }
      /deep/.el-input__inner {
        height: 33px;
        width: 80%;
      }
      /deep/.el-select {
        width: 160px;
        /deep/.el-input__inner {
          width: 100%;
        }
      }
      .el-col-7,.el-col-8,.el-col-9 {
        height: 32px;
      }
      /deep/.el-form-item {
        margin-bottom: 10px;
      }
      /deep/.el-form-item__label {
        padding: 0;
      }
    }
  }
  /deep/.el-button {
    width: 100px;
  }
  .footer {
    text-align: center;
  }      
}
</style>



// WEBPACK FOOTER //
// src/views/StandardMana/components/addProject.vue